import styled from 'styled-components';

const StyledFaq = styled.main`
  padding-bottom: 80px;
  flex-grow: 1;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  grid-template-columns: 240px 1fr;
  position: relative;

  .shop__wrap {
    margin-right: auto;
    margin-left: auto;
    display: grid;
    grid-template-rows: auto auto;
    grid-gap: 15px 40px;

    @media (max-width: 859px) {
      margin-top: 1.5rem;
      grid-template-columns: 1fr;
    }
    @media (min-width: 860px) {
      grid-template-columns: 240px 1fr;
    }
  }

  .shop__hero,
  .shop__aside {
    background-color: ${({ theme }) => theme.colors.white};
  }

  .shop__aside {
    padding-bottom: 24px;
    padding-left: 32px;
    height: fit-content;
    border-radius: 8px;
    position: relative;
    grid-row: 1 / span 10;
    align-self: start;
  }

  .filter_loading {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.whiteTransparent};
    z-index: 5;
    .placeholder__loading {
      text-align: center;
      align-items: center;
    }
  }

  .shop__aside__filter {
    &:not(:first-of-type) {
      margin-top: 24px;
      padding-top: 24px;
      border-top: 1px solid ${({ theme }) => theme.colors.gray2};
    }
  }

  .shop__hero {
    @media (max-width: 859px) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.gray2};
    }
    @media (min-width: 860px) {
      margin-top: 0.5rem;
    }
  }

  .shop__hero__half {
    &.desktop {
      padding: 30px 0;
    }
    @media (min-width: 860px) {
      margin-right: auto;
    }
  }

  .shop__hero__headings {
    margin-right: auto;
    margin-left: auto;
    padding: 1.5rem 32px;
    display: flex;
    align-items: center;

    @media (max-width: 859px) {
      justify-content: center;
      text-align: center;
    }
  }

  .shop__products {
    height: max-content;
    display: grid;
    grid-template-rows: auto;

    @media (max-width: 559px) {
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      grid-gap: 40px 8px;
    }
    @media (min-width: 560px) {
      grid-template-columns: repeat(auto-fill, minmax(222px, 1fr));
    }
    @media (min-width: 560px) and (max-width: 859px) {
      margin-right: 24px;
      margin-left: 24px;
      grid-gap: 40px 16px;
    }
    @media (max-width: 860px) {
      justify-content: center;
    }
    @media (min-width: 860px) {
      margin-right: 32px;
      grid-gap: 64px 32px;
    }
  }

  .shop__no-results {
    text-align: center;
    padding-right: 8px;
    padding-left: 8px;
  }

  .shop__no-results__icon {
    margin-bottom: 1rem;
    width: 75px;
    height: 75px;
    fill: ${({ theme }) => theme.colors.gray3};
  }

  .shop__no-results__heading {
    margin-bottom: 0.75rem;
    color: ${({ theme }) => theme.colors.gray4};
  }

  .shop__no-results__copy {
    color: ${({ theme }) => theme.colors.gray4};
  }

  .shop__loading {
    margin-top: 1rem;
    grid-column-start: 2;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      fill: ${({ theme }) => theme.colors.gray3};
    }
  }
  .shop__loading-products {
    margin-top: 1rem;
    grid-column-start: 2;
    display: flex;
    justify-content: center;
  }
  .shop__hero__display {
    color: ${({ theme }) => theme.colors.brandDark};
  }

  .shop__hero__title {
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.colors.gray3};
  }

  .disabled__filters {
    .filter-product-price__radio,
    .filter-product-type__type {
      opacity: 0.5;
    }
  }
  .shop__breadcrumb {
    text-decoration: none;
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 859px) {
      padding: 0 10px;
    }
  }
  .shop__breadcrumb button {
    text-decoration: none;
    background-image: linear-gradient(#000, #000);
    background-position: 0 100%; /*OR bottom left*/
    background-size: 0% 2px;
    background-repeat: no-repeat;
    transition:
      background-size 0.3s,
      background-position 0s 0.3s;

    &:hover,
    &:focus {
      text-decoration: none;
      background-position: 100% 100%;
      background-size: 100% 1px;
    }
  }
  .banner-surf {
    width: 100%;
    margin-bottom: 15px;
    @media (min-width: 860px) {
      max-width: calc(100% - 32px);
    }
  }
  .banner-shop {
    width: 100%;
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
    @media (min-width: 860px) {
      max-width: calc(100% - 32px);
    }
    img {
      max-width: 100%;
      margin: 0 auto;
      &.mobile-banner {
        display: none;
      }
      @media (max-width: 768px) {
        &.mobile-banner {
          display: block;
        }
        &.desktop-banner {
          display: none;
        }
      }
    }
  }
  .shop-content__container {
    padding-right: 32px;

    @media (max-width: 859px) {
      padding: 0 24px;
    }
  }
  .title-section {
    width: 100%;
    margin-bottom: 10px;
    margin-top: 10px;

    &.categories {
      margin-top: 20px;
    }

    @media (min-width: 860px) {
      grid-column-start: 2;
    }

    .title__heading {
      font-size: 40px;
      color: ${({ theme }) => theme.colors.brandDark};
      margin-bottom: 10px;

      &.modify {
        font-size: 35px;
        margin-bottom: 15px;
      }
    }

    .title__desc {
      font-size: 16px;
      line-height: 25px;
      color: ${({ theme }) => theme.colors.brandDark};
    }

    .show__more {
      text-decoration: underline;
      color: ${({ theme }) => theme.colors.brandDark};
      display: block;
      width: fit-content;
      margin-left: auto;
    }
  }
  .key-attributes-block {
    display: flex;
    gap: 60px;
    align-items: flex-start;
    margin-top: 60px;
    margin-bottom: 10px;

    @media (min-width: 860px) {
      grid-column-start: 2;
    }

    @media (max-width: 860px) {
      flex-direction: column;
      gap: 24px;
    }

    &__title {
      flex: 0 1 450px;
      max-width: 450px;
      font-size: 35px;
      line-height: 1.2;
      color: ${({ theme }) => theme.colors.brandDark};

      @media (max-width: 860px) {
        flex: none;
        width: 100%;
        max-width: 100%;
        font-size: 26px;
      }
    }

    &__content {
      flex: 1;
      width: 100%;
    }

    &__list {
      list-style: none;
      padding: 0;
      margin: 0 0 20px;
      border-top: 1px solid #e0e0e0;

      li {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 14px 0;
        border-bottom: 1px solid #e0e0e0;
        font-size: 16px;
        color: ${({ theme }) => theme.colors.brandDark};

        &::before {
          content: '•';
          font-size: 20px;
          flex-shrink: 0;
        }
      }
    }

    &__desc {
      font-size: 14px;
      line-height: 1.6;
      color: ${({ theme }) => theme.colors.brandDark};
    }
  }

  .faq-block {
    margin-top: 60px;
    margin-bottom: 10px;

    @media (min-width: 860px) {
      grid-column-start: 2;
    }

    &__title {
      font-size: 35px;
      color: ${({ theme }) => theme.colors.brandDark};
      margin-bottom: 32px;
      text-align: center;
    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: 12px;
      max-width: 800px;
      margin: 0 auto;
    }

    &__item {
      background-color: #f5f0e8;
      border-radius: 8px;
      padding: 20px 24px;
      cursor: pointer;
      user-select: none;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: #ede8df;

        .faq-block__question span {
          color: ${({ theme }) => theme.colors.brand};
        }
      }
    }

    &__question {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      font-size: 16px;
      font-weight: 700;
      color: ${({ theme }) => theme.colors.brandDark};
    }

    &__icon {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      color: ${({ theme }) => theme.colors.brandDark};
      transition: transform 0.35s ease;
    }

    &__item--open &__icon {
      transform: rotate(180deg);
    }

    &__answer {
      display: grid;
      grid-template-rows: 0fr;
      opacity: 0;
      transition:
        grid-template-rows 0.35s ease,
        opacity 0.3s ease;

      > p {
        overflow: hidden;
        min-height: 0;
        padding-top: 0;
        font-size: 16px;
        line-height: 1.6;
        color: ${({ theme }) => theme.colors.brandDark};
        transition: padding-top 0.35s ease;
      }

      &--open {
        grid-template-rows: 1fr;
        opacity: 1;

        > p {
          padding-top: 16px;
        }
      }
    }
  }

  .where-to-buy-block {
    display: flex;
    gap: 60px;
    margin-top: 60px;
    margin-bottom: 10px;

    @media (min-width: 860px) {
      grid-column-start: 2;
    }

    @media (max-width: 859px) {
      flex-direction: column;
      gap: 24px;
      .where-to-buy-block__image {
        flex: 1;
      }
    }

    &__image {
      flex: 0 1 450px;
      max-width: 450px;

      img {
        width: 100%;
        height: auto;
        display: block;
        border-radius: 8px;
        object-fit: cover;
      }
    }

    &__content {
      flex: 1;
    }

    &__title {
      font-size: 35px;
      color: ${({ theme }) => theme.colors.brandDark};
      margin-bottom: 24px;

      @media (max-width: 859px) {
        font-size: 26px;
      }
    }

    &__desc {
      font-size: 16px;
      color: ${({ theme }) => theme.colors.brandDark};
    }
  }

  .shop-by-brand-wrap {
    @media (min-width: 860px) {
      grid-column-start: 2;
    }
  }

  .sort-by-desktop {
    width: 100%;
    padding: 0.5rem 32px;
    display: flex;
    justify-content: flex-end;
  }
  .default_styles {
    img {
      max-width: 100%;
    }
    * {
      all: revert;
      box-sizing: border-box;
      color: inherit;
      line-height: normal;
    }
  }
  .t-title-mod {
    font-family: var(--font-artifex) !important;
  }
`;

export default StyledFaq;
